// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flashlight"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8 23H16V10L19 7V4.5H5V7L8 10V23Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M19 1H5V4.5H19V1Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 4.5V7L8 10V23H16V10L19 7V4.5M5 4.5H19M5 4.5V1H19V4.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 11H12.0039V11.0039H12V11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FlashlightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flashlight',
    ref,
    icon: element,
  },
));

FlashlightIcon.displayName = 'FlashlightIcon';

export default FlashlightIcon;
